const entorno = () => {
  if (!!process.env.NODE_ENV) {
    return process.env.NODE_ENV;
  } else {
    return "test";
  }
};

const ApiUri = {
  test: "https://localhost:5001",
  // * region [ rgba (10,80,10,0.3)] Modificar
  development: "https://colmenac.ugto.mx/daip/cepiug",
  production: "https://enjambrec.ugto.mx/daip/cepiug",
  // * endregion
};

const BaseUri = {
  test: "https://localhost:8080",
  // * region [ rgba (10,80,10,0.3)] Modificar
  development: "https://www.colmena.ugto.mx/cepiug",
  production: "https://intranet3.ugto.mx/cepiug",
  // * endregion
};

const baseUri = BaseUri[entorno()];
const baseApiUri = ApiUri[entorno()];

const oidcProps = {
  // * region [ rgba (10,80,10,0.3)] Modificar
  clientId: "30e85997-b514-4578-a8d2-fab07d42df1f",
  scope: "openid profile email offline_access",
  // * endregion
  redirectUri: `${baseUri}/oidc-callback`,
  silentRedirectUri: `${baseUri}/silent-renew-oidc.html`,
};

export default {
  oidcProps,
  baseApiUri: `${baseApiUri}/api`,
};
